import { SettingsNavigation, SETTINGS_NAVIGATION_VARIANT } from 'components/Settings';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, styled } from 'shell/components';
import { SettingsPageContext } from '../PageProvider';
import { flattenSettingsSections } from '../sectionRegistry';
import SettingsSections from '../shared/sections';

const MobileSettings = () => {
    const { groups } = useContext(SettingsPageContext);
    const { t } = useTranslation();
    const sections = flattenSettingsSections(groups);
    const labels = Object.fromEntries([
        ...groups.map(({ id, labelKey, fallback }) => [id, t(labelKey, fallback)]),
        ...sections.map(({ id, labelKey, fallback }) => [id, t(labelKey, fallback)]),
    ]);

    return (
        <Stack sx={{ backgroundColor: 'ensightful.shades.0', minWidth: 0, width: '100%' }}>
            <SettingsNavigation
                groups={groups}
                labels={labels}
                variant={SETTINGS_NAVIGATION_VARIANT.HORIZONTAL}
                ariaLabel={t('settings.navigation', 'Settings navigation')}
            />
            <Content>
                <SettingsSections />
            </Content>
        </Stack>
    );
};

const Content = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(3),
    width: '100%',

    '& [data-settings-section]': {
        scrollMarginTop: theme.spacing(12),
    },
}));

export default MobileSettings;
